import CompletedRefundSection from '@/components/sideNavigation/Cs/common/CompletedRefundSection';
import CompleteRequestWrapper from '@/components/sideNavigation/Cs/common/CompleteRequestWrapper';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import {
  setFilterKeyword,
  setFilterOrderBy,
  setFilterSeletor,
} from '@/store/modules/refund';
import { RefundCreateAccept } from '@/types/cs.type';
import { Button } from '@successmode-ktp/kui';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  type?:
    | 'REFUND_CREATE_ACCEPTED'
    | 'REFUND_CREATE_CONFIRMED'
    | 'REFUND_CREATE_REJECTED';
  reasonResult?: string | null;
  refundInfo?: RefundCreateAccept;
};

function ResultRefundSection({ type, reasonResult = '', refundInfo }: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onMoveToRefundList = async () => {
    await navigate('/refund-detail');

    dispatch(setFilterOrderBy('CREATED_DATE'));
    if (refundInfo?.touristName) {
      dispatch(setFilterKeyword(refundInfo.touristName));
    }

    if (refundInfo?.supplyDate) {
      dispatch(
        setFilterSeletor({
          startDate: new Date(refundInfo.supplyDate),
          endDate: new Date(refundInfo.supplyDate),
        }),
      );
    } else {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      dispatch(
        setFilterSeletor({
          startDate,
          endDate: new Date(),
        }),
      );
    }
  };

  const title =
    type === 'REFUND_CREATE_REJECTED'
      ? '환급건 등록에 실패했습니다'
      : type === 'REFUND_CREATE_CONFIRMED'
      ? '환급건이 정상적으로 등록되었습니다'
      : '정상적으로 요청되었습니다';

  const description =
    type === 'REFUND_CREATE_REJECTED'
      ? '실패 사유는 아래 상세 내용을 확인해주세요'
      : '';

  return (
    <CompleteRequestWrapper
      isFail={type === 'REFUND_CREATE_REJECTED'}
      title={title}
      description={description}
      content={
        <CompletedRefundSection
          supplyDate={refundInfo?.supplyDate || ''}
          touristName={refundInfo?.touristName || ''}
          productAmount={refundInfo?.productAmount || 0}
          reason={refundInfo?.reason || ''}
        />
      }
      bottomSection={
        type === 'REFUND_CREATE_REJECTED' && reasonResult ? (
          <RejectedReason>{reasonResult}</RejectedReason>
        ) : type === 'REFUND_CREATE_CONFIRMED' ? (
          <Button onClick={onMoveToRefundList}>환급 내역으로 이동하기</Button>
        ) : null
      }
    />
  );
}

const RejectedReason = styled.div`
  width: 100%;
  border-radius: 6px;
  padding: 10px 20px;
  background-color: #fff4f6;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -2%;
  color: #ff2d55e5;
`;

export default ResultRefundSection;
